var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLawyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Witnes_",
    "data-name": "Witnes ",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6925",
    "data-name": "Rect\\xE1ngulo 6925",
    width: 22.136,
    height: 21.145
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6677",
    "data-name": "Rect\\xE1ngulo 6677",
    width: 36,
    height: 36,
    transform: "translate(0 0)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(13.964 12.707)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Cont",
    width: 19.362,
    height: 19.362,
    transform: "translate(-3.623 -3.279)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17504",
    "data-name": "Grupo 17504",
    transform: "translate(-6.397 -5.496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17503",
    "data-name": "Grupo 17503",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19433",
    "data-name": "Trazado 19433",
    d: "M342.656,6.44a1.127,1.127,0,0,1-1.132-.318q-3.515-2.968-4.485-3.778c-.731-.613.092-1.532.548-1.989.641-.644,1.171-.314,1.793.225q.979.847,3.595,3c.22.181.461.4.651.591a1.13,1.13,0,0,1,.079,1.255,2.84,2.84,0,0,1-1.049,1.012",
    transform: "translate(-326.459 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19434",
    "data-name": "Trazado 19434",
    d: "M219.476,100.31l-1.1,1.214a.081.081,0,0,0,0,.105,3.786,3.786,0,0,0,.427.375q1.394,1.124,7.473,6.049a2.23,2.23,0,0,1,.335.475c.7,1.165-.778,2.641-1.9,1.842a5.513,5.513,0,0,1-.679-.578q-.645-.641-1.908-1.836-4.8-4.538-5.1-4.841a.082.082,0,0,0-.116,0l0,.005-.915,1.087a.074.074,0,0,1-.1.009l-4.753-4a.078.078,0,0,1-.009-.11h0l3.363-3.93a.065.065,0,0,1,.061-.022.56.56,0,0,1,.225.135q1.976,1.695,4.706,3.965a.041.041,0,0,1,.006.058v0",
    transform: "translate(-204.65 -93.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19435",
    "data-name": "Trazado 19435",
    d: "M124.6,245.473q1.994,1.677,2.272,1.917c.589.51.332,1.17-.093,1.691s-.75.9-1.52.761a.227.227,0,0,1-.075-.027,4,4,0,0,1-.642-.445q-.569-.485-1.882-1.589t-1.888-1.58a4,4,0,0,1-.548-.557.227.227,0,0,1-.039-.069c-.274-.734.047-1.119.488-1.628s1.047-.874,1.65-.382q.284.232,2.278,1.908",
    transform: "translate(-116.414 -235.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19436",
    "data-name": "Trazado 19436",
    d: "M1.589,529.233a11.541,11.541,0,0,1,.033-1.257c.054-.373.229-.591.624-.589q2.343.01,8.17.006a3.048,3.048,0,0,1,.561.026c.286.1.3.309.306.62q0,.238,0,1.207a.057.057,0,0,0,.058.057c.723,0,1.524.129,1.6,1.018a9.389,9.389,0,0,1,0,1.406c-.058.838-.658.68-1.228.679q-8.008-.007-10.868,0a2.667,2.667,0,0,1-.35-.014c-.338-.05-.449-.349-.472-.656a11.593,11.593,0,0,1-.015-1.276.992.992,0,0,1,.533-.965,2.562,2.562,0,0,1,.978-.2.069.069,0,0,0,.067-.067",
    transform: "translate(-0.001 -511.273)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawyer);
export default __webpack_public_path__ + "static/media/lawyer.52e95598ad262e04d3a766c939a2b334.svg";
export { ForwardRef as ReactComponent };